import * as Yup from "yup";

export const structure = (formHead, t) => [
  {
    head: formHead,
    width: "100%",
    list: [
      {
        name: `password`,
        kind: "input",
        type: "text",
        label: `${t("vendors.label_password")}*`,
        width: "47%",
        placeholder: t("vendors.placeholder_write_password"),
      },
      {
        name: `confirmPassword`,
        kind: "input",
        type: "text",
        label: `${t("vendors.label_confirm_password")}*`,
        width: "47%",
        placeholder: t("vendors.label_confirm_password"),
      },
    ],
  },
];

export const validationSchema = (t) =>
  Yup.object({
    password: Yup.string()
      .required(t("vendors.error_required"))
      .min(6, t("vendors.error_password_min")),
    confirmPassword: Yup.string()
      .required(t("vendors.error_required"))
      .oneOf(
        [Yup.ref("password"), null],
        t("vendors.error_passwords_mismatch"),
      ),
  });
